import USER_ROLES from '../../constants/userRoles.constants';

class RecentEvaluationsController {

    switchToAll() {
        this.visibleList = this.currentEvaluations;
        this.me = false;
    }

    filterEditedByMe() {
        this.visibleList = this.currentMineEvaluations;
        this.me = true;
    }

    constructor($q, $state, $mdDialog, userService, evaluationService) {
        let self = this;
        this.userService = userService;
        this.isAdmin = this.userService.isInRole(USER_ROLES.ROLE_ADMIN);

        if(this.isAdmin) {
            $q.all([
                evaluationService.getLatestEvaluation(0),
                evaluationService.getLatestEvaluation(this.userService.currentUser.id)
            ]).then(res => {
                self.currentEvaluations = res[0];
                self.currentMineEvaluations = res[1];

                self.switchToAll();
            });
        } else {
            $q.all([
                evaluationService.getLatestEvaluation(this.userService.currentUser.id),
                evaluationService.getLatestInvitations()
            ]).then(res => {
                self.currentMineEvaluations = res[0];
                self.newEvaluations = res[1];
            });
        }

        this.openEvaluation = (evaluation) => {
            const found = evaluation.subEvaluations.find((subEvaluation) => {
               return subEvaluation.user.id === userService.currentUser.id;
            });
            if(found) {
                self.goToEvaluation(found);
            } else {
                self.joinEvaluationPopup(evaluation)
            }
        };

        this.joinInvitationPopup = (evaluation) => {
            $mdDialog.show({
                clickOutsideToClose: true,
                templateUrl: 'joinEvaluation.tmpl.html',
                parent: angular.element(document.body),
                multiple: false,
                locals: {
                    evaluation: evaluation
                },
                controller: function DialogController($scope, $mdDialog, evaluation) {
                    $scope.evaluation = evaluation;
                    $scope.closeDialog = () => {
                        $mdDialog.cancel();
                    };
                    $scope.join = () => {
                        $mdDialog.hide();
                    };
                },
            })
            .then(() => {
                $state.go('mini.basicInfo', {id: evaluation.id});
            }, () => {});
        };

        this.joinEvaluationPopup = (evaluation) => {
            $mdDialog.show({
                clickOutsideToClose: true,
                templateUrl: 'joinEvaluation.tmpl.html',
                parent: angular.element(document.body),
                multiple: false,
                locals: {
                    evaluation: evaluation
                },
                controller: function DialogController($scope, $mdDialog, evaluation) {
                    $scope.evaluation = evaluation;
                    $scope.closeDialog = () => {
                        $mdDialog.cancel();
                    };
                    $scope.join = () => {
                        $mdDialog.hide();
                    };
                },
            })
            .then(() => {
                evaluationService.getJoinId(evaluation.id).then((response) => {
                    let stateMode = evaluation.isMini ? 'mini' : 'evaluation';
                    $state.go(stateMode + '.basicInfo', {id: response.id});
                });
            }, () => {});
        };

        this.goToEvaluation = (evaluation) => {
            let stateMode = evaluation.isMini ? 'mini' : 'evaluation';
            $state.go(stateMode + '.basicInfo', {id: evaluation.id});
        };
    }

}

RecentEvaluationsController.$inject = ['$q', '$state', '$mdDialog', 'UserService', 'EvaluationService'];

export default RecentEvaluationsController;



// WEBPACK FOOTER //
// ./src/app/components/recentEvaluations/RecentEvaluationsController.js